import React from "react";
import { PageHero, Section, FACILITIES } from "./_shared";
import { Building2, Cpu, BookOpen, PencilRuler, Wrench, Briefcase } from "lucide-react";

const ICONS = {
  "Spacious Grand Building": Building2,
  "Modern Computer Lab": Cpu,
  "Well-equipped Library": BookOpen,
  "Engineering Drawing Hall": PencilRuler,
  "Trade Workshops": Wrench,
  "Employment & Self-Employment Cell": Briefcase,
};

export default function Facilities() {
  return (
    <div data-testid="mitsol-facilities">
      <PageHero
        eyebrow="Campus & Facilities"
        title="Purpose-built for hands-on training"
        sub="From dedicated trade workshops to a modern computer lab and a well-equipped library — every space is designed for practical, industry-oriented learning."
      />
      <Section>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FACILITIES.map((f, i) => {
            const Icon = ICONS[f.title] || Building2;
            return (
              <div key={i} className="group bg-white border border-slate-200 hover:border-[#F97316] hover:-translate-y-1 transition-all overflow-hidden" data-testid={`mitsol-facility-${i}`}>
                <div className="h-32 relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${i % 2 ? "#0F2A47" : "#F97316"}, ${i % 2 ? "#123055" : "#EAB308"})` }}>
                  <div className="absolute inset-0 flex items-center justify-center text-white/90">
                    <Icon size={48} strokeWidth={1.4} />
                  </div>
                  <div className="absolute top-3 right-3 text-white/80 font-mono text-xs">0{i + 1}</div>
                </div>
                <div className="p-5">
                  <div className="font-serif text-lg text-[#0F2A47] leading-tight">{f.title}</div>
                  <div className="text-[11px] text-slate-500 italic mt-0.5">{f.mr}</div>
                  <p className="mt-3 text-sm text-slate-700 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
